module.exports = __webpack_public_path__ + "img/profile_box_sex.31c1fdfc.svg";